App = App || {};

App.MemberRolesOffcanvas = (function ($, Vue) {
	"use strict";

	var $modal;

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("member-roles-app");
		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = "1";

		$modal = $(rootElement).closest(".modal");

		new Vue({
			el: rootElement,
			data: {
				model: {
					id: "",
					roles: []
				},
				isLoading: false,
				isSubmitting: false,
				isComplete: false,
				alertMessage: "",
				alertErrors: [],
				memberRoles: [],
				courseRoleDefs: []
			},
			methods: {
				reset: function () {
					this.isLoading = false;
					this.isSubmitting = false;
					this.isComplete = false;
					this.alertMessage = "";
					this.alertErrors = [];
				},

				close: function () {
					$modal.modal("hide");
				},

				getRoles: function () {
					this.model.id = $modal.data("id");

					if (!this.model.id) {
						this.alertMessage = "No item id provided.";
						return;
					}

					$.ajax({
						url: "/api/members/roles/" + encodeURIComponent(this.model.id),
						method: "GET",
						contentType: "application/json",
						timeout: 10000,
						headers: { "Accept": "application/json" }
					}).done(response => {
						if (response && response.success) {
							this.model.roles = Array.isArray(response.data.roles) ? response.data.roles : [];
						} else {
							this.alertMessage = (response && response.message) || "Assignment failed.";
							this.$nextTick(() => this.$refs.topAlert && this.$refs.topAlert.focus && this.$refs.topAlert.focus({ preventScroll: true }));
						}
					}).fail((jq, status, err) => {
						if (status !== "abort") {
							console.error("AJAX error posting adjustment:", status, err);
							this.alertMessage = jq.status === 404
								? "Endpoint not found (404)."
								: (status === "timeout" ? "Request timed out." : "Assignment failed.");
							this.$nextTick(() => this.$refs.topAlert && this.$refs.topAlert.focus && this.$refs.topAlert.focus({ preventScroll: true }));
						}
					}).always(() => {
						this.isSubmitting = false;
					});
				},

				loadMemberRoles: function () {
					return $.ajax({
						url: "/api/lookups/member_roles",
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 10000
					}).done((resp) => {
						if (resp && resp.success && Array.isArray(resp.data)) {
							this.memberRoles = resp.data;
						} else {
							this.memberRoles = [];
						}
					}).fail(() => {
						this.memberRoles = [];
					});
				},

				loadCourseRoleDefs: function () {
					return $.ajax({
						url: "/api/lookups/course-roles",
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 10000
					}).done((resp) => {
						if (resp && resp.success && Array.isArray(resp.data)) {
							this.courseRoleDefs = resp.data;
						} else {
							this.courseRoleDefs = [];
						}
					}).fail(() => {
						this.courseRoleDefs = [];
					});
				},

				submit: function () {
					this.isSubmitting = true;
					this.alertMessage = "";
					this.alertErrors = [];
					this.isComplete = false;

					$.ajax({
						url: "/api/members/roles",
						method: "POST",
						contentType: "application/json",
						data: JSON.stringify(this.model),
						timeout: 10000,
						headers: { "Accept": "application/json" }
					}).done(response => {
						if (response && response.success) {
							this.isComplete = true;
							setTimeout(() => {
								this.close();
							}, 900);
						} else {
							this.alertMessage = (response && response.message) || "Assignment failed.";

							this.alertErrors = ((response && response.data && response.data.errors) || [])
								.map(e => e.description || e).filter(Boolean);

							this.$nextTick(() => this.$refs.topAlert && this.$refs.topAlert.focus && this.$refs.topAlert.focus({ preventScroll: true }));
						}
					}).fail((jq, status, err) => {
						if (status !== "abort") {
							console.error("AJAX error posting adjustment:", status, err);
							this.alertMessage = jq.status === 404
								? "Endpoint not found (404)."
								: (status === "timeout" ? "Request timed out." : "Assignment failed.");
							this.$nextTick(() => this.$refs.topAlert && this.$refs.topAlert.focus && this.$refs.topAlert.focus({ preventScroll: true }));
						}
					}).always(() => {
						this.isSubmitting = false;
					});
				}
			},
			mounted: function () {
				$modal.off('show.bs.modal hidden.bs.modal');

				$modal.on('show.bs.modal', (event) => {
					this.reset();
					this.isLoading = true;
					$.when(
						this.getRoles(),
						this.loadCourseRoleDefs(),
						this.loadMemberRoles()
					).always(() => {
						this.isLoading = false;
					});
				});

				$modal.on("shown.bs.modal", () => {
					$modal.find("#close-icon").focus();
				});
			}
		});
	}

	function open(id, onClose) {
		$modal.data("id", id).modal("show");

		if (onClose) {
			$modal.one('hidden.bs.modal', onClose);
		}
	}

	return {
		init,
		open
	};
})(jQuery, Vue);

App.MemberRolesOffcanvas.init();